import { render } from "./AddCfpModal.vue?vue&type=template&id=6487f826"
import script from "./AddCfpModal.vue?vue&type=script&lang=js"
export * from "./AddCfpModal.vue?vue&type=script&lang=js"

import "./AddCfpModal.vue?vue&type=style&index=0&id=6487f826&lang=css"
script.render = render

export default script